import React, { useCallback } from 'react';
import * as Styled from './CallPanel.styled';
import { Icon } from '@virtidev/toolbox';
import { useTheme } from 'styled-components';
import useStreamVolume from '@core/components/MicrophoneStreamProvider/useStreamVolume';
import { useTranslation } from 'react-i18next';

/**
 * @type {React.FC<{
 *  disabled?: boolean;
 *  vhName?: string;
 *  onHangUp?: () => void;
 *  muted?: boolean;
 *  onMuteChange?: (newMuted: boolean) => void;
 *  micStream?: MediaStream;
 * }>}
 * */
const CallPanel = ({
  disabled,
  vhName,
  onHangUp,
  muted,
  onMuteChange,
  micStream,
}) => {
  const { color } = useTheme();

  const handleClickMicrophone = useCallback(() => {
    if (!onMuteChange) return;
    onMuteChange(!muted);
  }, [muted, onMuteChange]);

  const volume = useStreamVolume(micStream);
  let scale = 1;
  if (volume > 0.01) {
    const multiplier = 4 * volume;
    scale += multiplier;
    scale = Math.min(1.3, scale);
  }

  const { t } = useTranslation();

  return (
    <Styled.Panel>
      <div>
        <Styled.OnlineIndicator>
          {vhName} {disabled ? t('isOffline') : t('isOnline')}{' '}
          <div>
            <Styled.OnlineIndicatorDot $online={!disabled} />
          </div>
        </Styled.OnlineIndicator>
      </div>
      <Styled.PanelButtons>
        <Styled.PanelButton
          title={t('voiceMode')}
          tooltipId="mic"
          disabled={disabled}
          onClick={handleClickMicrophone}
          round={true}
        >
          <Styled.StyledPulseCircle
            style={{
              transform: `scale(${scale})`,
            }}
          />
          <Icon
            size="1.4rem"
            icon={muted ? 'microphoneoff' : 'microphone'}
            type="outline"
            color={disabled ? color.darkGrey : color.midnight5}
          />
        </Styled.PanelButton>
        <Styled.HangUpButton
          title={t('endCall')}
          tooltipId="hangup"
          onClick={onHangUp}
          disabled={disabled}
          round={true}
        >
          <Icon
            size="1.4rem"
            icon="phone"
            type="outline"
            color={disabled ? color.darkGrey : color.white}
          />
        </Styled.HangUpButton>
      </Styled.PanelButtons>
      <div></div>
    </Styled.Panel>
  );
};

export default CallPanel;
